import { render, staticRenderFns } from "./IntegrationFormSlack.vue?vue&type=template&id=f272414a&scoped=true"
import script from "./IntegrationFormSlack.vue?vue&type=script&lang=js"
export * from "./IntegrationFormSlack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f272414a",
  null
  
)

export default component.exports